import PropTypes from 'prop-types';
import React from 'react';

/**
 * Atom: a text link with an optional leading icon (Figma "link w icon").
 *
 * `icon` is an imported SVG ReactComponent — pass an icon whose paths use
 * `fill="currentColor"` so it inherits the link color and hover state.
 */
const LinkButton = ({ icon: Icon, label, onClick, disabled, testId }) => (
	<button
		type="button"
		className="link-button"
		onClick={onClick}
		disabled={disabled}
		data-testid={testId}
	>
		{Icon ? <Icon className="link-button-icon" /> : null}
		<span>{label}</span>
	</button>
);

LinkButton.propTypes = {
	icon: PropTypes.elementType,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	testId: PropTypes.string
};

LinkButton.defaultProps = {
	icon: null,
	onClick: undefined,
	disabled: false,
	testId: undefined
};

export default LinkButton;
